import { axios } from '@Root/API'

export const getStudiesSuspensionsOptions = () => {
	return axios.get('data-for-course-session-suspensions')
}
